<page-sections [page]="page" [editMode]="editMode"></page-sections>
<registry *ngIf="registry" [registry]="registry" [editMode]="editMode"></registry>
